/**
 * 孩子档案预设头像
 *
 * 8 个可爱的卡通动物头像，用于孩子档案展示
 * 资源位于 /public/images/avatars/
 */

// 头像 key 类型
export type AvatarKey = 'bear' | 'bunny' | 'lion' | 'cat' | 'dog' | 'panda' | 'fox' | 'owl';

// 头像 URL 映射
export const avatarUrls: Record<AvatarKey, string> = {
  bear: '/images/avatars/bear.png',
  bunny: '/images/avatars/bunny.png',
  lion: '/images/avatars/lion.png',
  cat: '/images/avatars/cat.png',
  dog: '/images/avatars/dog.png',
  panda: '/images/avatars/panda.png',
  fox: '/images/avatars/fox.png',
  owl: '/images/avatars/owl.png',
};

// 头像选项列表
export const AVATAR_OPTIONS: {
  key: AvatarKey;
  label: string;
  labelEn: string;
}[] = [
  { key: 'bear', label: '小熊', labelEn: 'Bear' },
  { key: 'bunny', label: '小兔', labelEn: 'Bunny' },
  { key: 'lion', label: '小狮', labelEn: 'Lion' },
  { key: 'cat', label: '小猫', labelEn: 'Cat' },
  { key: 'dog', label: '小狗', labelEn: 'Dog' },
  { key: 'panda', label: '熊猫', labelEn: 'Panda' },
  { key: 'fox', label: '小狐', labelEn: 'Fox' },
  { key: 'owl', label: '猫头鹰', labelEn: 'Owl' },
];

// 默认头像
export const DEFAULT_AVATAR: AvatarKey = 'bear';

/**
 * 获取头像 URL
 */
export function getAvatarUrl(key: AvatarKey): string {
  return avatarUrls[key] || avatarUrls.bear;
}
